export const state = {
    isOpen: false,
    modalType: null,
    modalData: {},
    modalComponent: null,
}

export const getters = {
    isModalOpen: (state) => state.isOpen,
    currentModal: (state) => ({
        type: state.modalType,
        component: state.modalComponent,
        data: state.modalData,
    }),
    modalData: (state) => state.modalData,
}

export const mutations = {
    OPEN_MODAL(state, { type, component, data = {} }) {
        state.isOpen = true
        state.modalType = type
        state.modalComponent = component
        state.modalData = data
    },
    CLOSE_MODAL(state) {
        state.isOpen = false
        state.modalType = null
        state.modalComponent = null
        state.modalData = {}
    },
    SET_MODAL_DATA(state, data) {
        state.modalData = { ...state.modalData, ...data }
    },
}

export const actions = {
    showModal({ commit }, { type, component, data }) {
        commit('OPEN_MODAL', { type, component, data })
    },
    hideModal({ commit }) {
        commit('CLOSE_MODAL')
    },
    replaceModal({ commit }, { type, component, data }) {
        commit('CLOSE_MODAL')
        setTimeout(() => {
            commit('OPEN_MODAL', { type, component, data })
        }, 50)
    },
    updateModalData({ commit }, data) {
        commit('SET_MODAL_DATA', data)
    },
}